// extracted by mini-css-extract-plugin
export default {"noDataInformation":"TableNoDataInformation_noDataInformation__Hjewy"};